import React, { useState } from "react";
import styled from 'styled-components';
import { getColor} from '@process-advisor/process-miner/shared/theme';
import { Event } from '@process-advisor/process-miner/api/events';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { downloadDiscoveryRule } from '@process-advisor/process-miner/processMiner/processMiner'
import { ProcessMinerGauges } from '@process-advisor/process-miner/navigation/topBar/processMinerGauges'
import { DiscoveryRuleDetails } from '@process-advisor/process-miner/discoveryRules/discoveryRuleDetails'

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 400px;
    height: 100%;
    background-color: ${getColor('white')};
    padding-top: 10px;
    padding-bottom: 10px;
`;
const Gauges = styled.div`
    margin-left: 50px;
`;


export const DownloadDiscoveryRule = () => {
    const [discovery_rule_id, setDiscoveryRuleID] = useState('');
    const [discoveryRule, setDiscoveryRule] = useState('');
    const [filterSummary, setFilterSummary] = useState('');

    useApiListener(
        Event.downloadDiscoveryRule,
        ({ discovery_rule_id , discoveryRule, filterSummary}) => {
           setDiscoveryRuleID(discovery_rule_id)
           setDiscoveryRule(discoveryRule)
           setFilterSummary(filterSummary)
           downloadDiscoveryRule(discovery_rule_id)
        }
    );

    useApiListener(
        Event.updateDiscoveryRuleDetail,
        ({ discovery_rule_id , discoveryRule, filterSummary}) => {
           setDiscoveryRuleID(discovery_rule_id)
           setDiscoveryRule(discoveryRule)
           setFilterSummary(filterSummary)
        }
    );

    return (
        <div >
            <div id="#discoveryRuleDetails" >
                 <DiscoveryRuleDetails discoveryRule={discoveryRule} filterSummary={filterSummary} />
            </div>
            <div id="#gauges">
                <Gauges>
                    <ProcessMinerGauges/>
                </Gauges>
            </div>
        </div>
    );
};

